import React, {ChangeEvent, useState} from "react";
import {observer} from "mobx-react";
import {InactivityTimeoutSettingsBox} from "./boxes/inactivity-timeout-settings.box";
import {useServices} from "../../react-hooks/use-services.hook";
import {TimeSpan} from "@sparkware/app-utils";
import {IModalDialogHandler} from "../../services/dialog/dialog.service.interface";
import {DropDownBox} from "./boxes/drop-down.box";
import {CyClass} from "../../../common/cy-classes";
import {ModalDialogActionsComponent} from "../modal-dialog/modal-dialog-actions.component";


interface InactivityTimeoutSettingsComponentProps {
    dialogHandler: IModalDialogHandler;
    analyticsCategory: string;
}

//inactivity_timeout_settings_title

export const InactivityTimeoutSettingsComponent: React.FC<InactivityTimeoutSettingsComponentProps> = observer((props) => {
    const services = useServices();

    const currentSettings = services.user.getInactivityTimeoutSettings();

    const [currentSelectedValue, setCurrentSelectedValue] = useState(currentSettings.possibleSessionTimeoutValues.find(v => v.totalMinutes === currentSettings.currentSessionTimeout.totalMinutes) ?? currentSettings.possibleSessionTimeoutValues[0]
                                                                                                            ?? services.user.getDefaultAccessTokenLifeTime());


    const sendAnalytics = (action: string, label?: string) =>  {
        services.analytics.sendAnalytics(props.analyticsCategory, action, label);
    }

    const renderOption = (timeSpan: TimeSpan) => {

        return (
            <option key={timeSpan.totalMinutes} value={timeSpan.totalMinutes}>
                {services.translation.translate('INACTIVITY_TIMEOUT_SETTINGS_MINUTES', {
                    minutes: timeSpan.totalMinutes
                })}
            </option>
        )
    }


    const onChange = (event: ChangeEvent<HTMLSelectElement>) => {
        setCurrentSelectedValue(TimeSpan.fromMinutes(parseInt(event.target.value)));
    }

    const onClick = () => {
        services.user.setInactivityTimeout(currentSelectedValue);
        if(currentSelectedValue.totalMinutes !== currentSettings.currentSessionTimeout.totalMinutes) {
            sendAnalytics('changed', currentSelectedValue.totalMinutes.toString());
        }
        props.dialogHandler.close();

    }


    return (
        <InactivityTimeoutSettingsBox>
            <div>{services.translation.translate('INACTIVITY_TIMEOUT_SETTINGS_LABEL')}</div>
            <DropDownBox value={currentSelectedValue.totalMinutes} onChange={onChange} hasError={false} width={"100%"} className={CyClass('cy-inactivity-timeout-select')}>
                {currentSettings.possibleSessionTimeoutValues.map(renderOption)}
            </DropDownBox>

            <ModalDialogActionsComponent primaryAction={{
                onClick: onClick,
                text:services.translation.translate('OK')
            }} />

        </InactivityTimeoutSettingsBox>
    );
});